import { zipCodeValidator } from "../validation/zipCodeValidator";

export { zipCodeValidator };
/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */
/*
formsections/index:
warningsName_la
"Merchandise
Parties
Entry
Transport
Bol
Sign"
*/
const initialState = {
  // initialValues
};

export default function FieldValidationReducer(state = initialState, action) {
  switch (action.type) {
    case "INITIALIZE_WARNINGS": {
      return Object.assign({}, state, action.payload);
    }
    case "CLEAR_VALIDATION_FIELD_ERROR": {
      const prevBl = state.validObjects_bl || {};
      if (!action.key || !prevBl[action.key]) {
        return state;
      }
      const validObjects_bl = { ...prevBl };
      delete validObjects_bl[action.key];
      const warnings = (state.warnings || []).filter(
        (w) => !(w.tab === action.tab && w.name === action.name)
      );
      return Object.assign({}, state, { validObjects_bl, warnings });
    }
    case "INITIALIZE_SERVER_WARNINGS": {
      return Object.assign({}, state, { ...action.payload });
    }
    case "INITIALIZE_VALUES_FIELD_VALIDATION": {
      return Object.assign({}, state, { ...action.payload });
    }
    case "RESET_FIELD_WARNINGS": {
      return Object.assign({}, state, { census_warnings: null });
    }
    case "UPDATE_FIELD_WARNINGS": {
      const census_warnings = state.census_warnings
        ? Object.assign(state.census_warnings)
        : [];
      census_warnings[
        action.warnings.code + "_" + action.warnings.merchandiseId
      ] = action.warnings;
      return Object.assign({}, state, { census_warnings: census_warnings });
    }
    case "UPDATE_FIELD_VALIDATION_OBJECT": {
      let newFields = state.fields.slice();
      let index = newFields.findIndex((el) => {
        return (
          el.id === action.field.id &&
          el.merchandiseId === action.field.merchandiseId
        );
      });
      newFields[index] = action.field;
      return Object.assign({}, state, { fields: newFields });
    }
    default:
      return state;
  }
}

const getFreightDataValidationError = (
  field,
  frieghtCharges,
  frieghtInsurance,
  otherDeductions,
  invoiceAmount
) => {
  let errors = [];
  let isblank = (str) => {
    if (typeof str !== "string") return false;
    return !str || str.trim() === "";
  };

  if (isblank(frieghtCharges)) {
    frieghtCharges = 0.0;
  }
  if (isblank(frieghtInsurance)) {
    frieghtInsurance = 0.0;
  }
  if (isblank(otherDeductions)) {
    otherDeductions = 0.0;
  }
  if (isblank(invoiceAmount)) {
    invoiceAmount = 0.0;
  }

  if (
    parseFloat(frieghtCharges) +
      parseFloat(frieghtInsurance) +
      parseFloat(otherDeductions) >
    parseFloat(invoiceAmount)
  ) {
    errors.push(
      "Sum of freight charges, freight insurance and other deductions cannot be greater than invoice amount."
    );
  }

  return errors;
};

export { getFreightDataValidationError };